import { globalRef, IllegalStateError } from '@amazon/vinyl-util'
import type { PlaybackEnv } from './PlaybackEnv'

const playbackEnvRef = globalRef<{ env: PlaybackEnv | null }>(() => ({ env: null }))

export function setPlaybackEnv(env: PlaybackEnv): void {
    playbackEnvRef.value.env = env
}

/** The installed env, or null before `setPlaybackEnv`. */
export function findPlaybackEnv(): PlaybackEnv | null {
    return playbackEnvRef.value.env
}

export function getPlaybackEnv(): PlaybackEnv {
    const { env } = playbackEnvRef.value
    if (!env) throw new IllegalStateError('No PlaybackEnv installed; call setPlaybackEnv first.')
    return env
}
